export const BUSINESS_TYPE_OPTIONS = [
  { value: "SOLE_PROPRIETOR", label: "Sole Proprietor" },
  { value: "LIMITED_LIABILITY_CORPORATION", label: "LLC" },
  { value: "CORPORATION", label: "Corporation" },
  { value: "PARTNERSHIP", label: "Partnership" },
  { value: "NON_PROFIT", label: "Nonprofit" },
  { value: "GOVERNMENT", label: "Government" },
];
